<button 
  class="add-button" 
  [class]="buttonClass"
  [disabled]="disabled"
  (click)="onClick()"
  [attr.aria-label]="ariaLabel || buttonText">
  <ng-container *ngIf="iconType === 'break-settings'; else defaultIconTemplate">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M10 6V10L12.5 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </ng-container>
  <ng-template #defaultIconTemplate>
    <ng-container *ngIf="iconType === 'reward-settings'; else plusIconTemplate">
      <img src="/assets/images/rewards/settings.svg" alt="Settings" width="20" height="20">
    </ng-container>
    <ng-template #plusIconTemplate>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4V16M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </ng-template>
  </ng-template>
  {{ buttonText }}
</button>
